import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import ScheduleTab from "./ScheduleTab";
import SetupTab from "./SetupTab";
import MapsTab from "./MapsTab";
import LogsTab from "./LogsTab";
import { CalendarDays, Settings2, Map, ListChecks } from "lucide-react";

const TABS = [
  { id: "schedule", label: "Weekly Schedule", icon: CalendarDays },
  { id: "setup", label: "Block Setup", icon: Settings2 },
  { id: "maps", label: "Ranch Maps", icon: Map },
  { id: "logs", label: "Irrigation Logs", icon: ListChecks },
];

export default function IrrigationHome() {
  const [tab, setTab] = useState("schedule");
  const [blocks, setBlocks] = useState(null);

  const loadBlocks = async () => {
    const { data } = await api.get("/irrigation/setup");
    setBlocks(data);
  };
  useEffect(() => { loadBlocks(); }, []);

  if (!blocks) return <div className="p-8 font-bold uppercase text-sm">Loading irrigation…</div>;

  return (
    <div className="space-y-5" data-testid="irrigation-page">
      <div>
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight" style={{ fontFamily: "'Fraunces', serif" }}>Irrigation</h1>
        <p className="text-stone-500 text-sm mt-1">Weekly schedules from ET, soil moisture and visual checks — gallons in, hours and sets out.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t.id} data-testid={`irr-tab-${t.id}`} onClick={() => setTab(t.id)}
            className={`h-11 px-4 text-xs font-bold uppercase border flex items-center gap-2 ${tab === t.id ? "bg-[#1F3D34] text-white border-[#1F3D34]" : "bg-white text-stone-600 border-stone-300"}`}>
            <t.icon size={14} /> {t.label}
          </button>
        ))}
      </div>
      {tab === "schedule" && <ScheduleTab blocks={blocks} goSetup={() => setTab("setup")} />}
      {tab === "setup" && <SetupTab blocks={blocks} onSaved={loadBlocks} />}
      {tab === "maps" && <MapsTab blocks={blocks} />}
      {tab === "logs" && <LogsTab />}
    </div>
  );
}
